import { ComponentPropsWithoutRef, useState } from 'react';
import { useCompanies } from 'store/companies';
import { SelectFilter } from 'components/filters';

interface Props<Multiple extends boolean>
  extends Pick<
    ComponentPropsWithoutRef<typeof SelectFilter>,
    'onClearFilter' | 'onCancel'
  > {
  value?: Multiple extends true ? string[] : string;
  multiple: Multiple;
  onApplyFilter: (value: Multiple extends true ? string[] : string) => void;
}

export const CompaniesFilter = <Multiple extends boolean>({
  multiple,
  value,
  onApplyFilter,
  onClearFilter,
  onCancel,
}: Props<Multiple>) => {
  const [search, setSearch] = useState('');

  const { data: companies, isLoading } = useCompanies({
    search,
    status: ['active'],
    pageSize: 99999,
  });

  return (
    <SelectFilter
      options={companies?.items.map((company) => ({
        key: company.id,
        label: company.name,
      }))}
      value={{ value }}
      onApplyFilter={({ value }) => onApplyFilter(value)}
      onClearFilter={onClearFilter}
      onCancel={onCancel}
      loadingOptions={isLoading}
      onSearch={setSearch}
      asyncSearch
      multiple={multiple}
    />
  );
};
